import { Navigate } from 'react-router-dom'
import { useAuthStore, useEffectiveRole } from '@/store/auth'
import type { Role } from '@/types'
import type { ReactNode } from 'react'

export function RequireAuth({ children }: { children: ReactNode }) {
  const token = useAuthStore((s) => s.accessToken)
  if (!token) return <Navigate to="/login" replace />
  return <>{children}</>
}

/**
 * Проверяет, что у пользователя есть одна из указанных ролей.
 * Учитывает previewRole (предпросмотр интерфейса директором).
 */
export function RequireRole({ roles, children }: { roles: Role[]; children: ReactNode }) {
  const effectiveRole = useEffectiveRole()
  if (!effectiveRole || !roles.includes(effectiveRole)) return <Navigate to="/projects" replace />
  return <>{children}</>
}

/** Перенаправляет на /complete-profile пока профиль не заполнен. */
export function RequireProfile({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user)
  // Пока пользователь не загружен — ждём (не редиректим)
  if (!user) return <>{children}</>
  if (!user.profile_completed) return <Navigate to="/complete-profile" replace />
  return <>{children}</>
}
